import { BodyText } from "@/components/ui/Text";
import type { ChatMessage } from "../../types/chatMessageTypes";

interface PinMessageProps {
  message: ChatMessage;
}

export const PinMessage = ({ message }: PinMessageProps) => {
  return (
    <div className="flex flex-col gap-1">
      {message.title && (
        <BodyText size="sm" className="self-center">
          {message.title}
        </BodyText>
      )}
      {message.text && (
        <BodyText size="sm" textColor="tertiary" className="self-center">
          {message.text}
        </BodyText>
      )}
    </div>
  );
};
